/**
 * @file SearchCustomer.jsx
 * @description SearchCustomer component for displaying and managing search customer.
 * @component SearchCustomer
 * @exports SearchCustomer - Main component for displaying and managing search customer.
 */

import { Button, Box } from "@mui/material";
import {useState} from "react";
import {  VARIANTS, BUTTON_COLORS, SIZES } from "../../../common/constants/commonConstants";
import { INCOMING_CALLS_STRINGS } from "../../../common/constants/agentModule/incomingCallsConstants";
import SearchCustomerModel from "./SearchCustomerModel";

const SearchCustomer = ({ onCustomerGuid }) => {
  const [open, setOpen] = useState(false)

  return (
    <Box>
      {/* <Button
        variant={VARIANTS.CONTAINED}  
        color={BUTTON_COLORS.PRIMARY}
        size={SIZES.SMALL}
        onClick={() => setOpen(true)}
        title={INCOMING_CALLS_STRINGS.CUSTOMER_NOT_FOUND}
      >
        {INCOMING_CALLS_STRINGS.SEARCH_CUSTOMER}
      </Button> */}

       <div style={{ cursor: "pointer" }} onClick={() => setOpen(true)}>
         {INCOMING_CALLS_STRINGS.SEARCH_CUSTOMER}
      </div>

      {open && (<SearchCustomerModel open={open} onClose={()=> setOpen(false)} onCustomerGuid={onCustomerGuid}></SearchCustomerModel>)}
    </Box>
  );
};

export default SearchCustomer;
